import { render, staticRenderFns } from "./Team.vue?vue&type=template&id=04063956&scoped=true"
import script from "./Team.vue?vue&type=script&lang=js"
export * from "./Team.vue?vue&type=script&lang=js"
import style0 from "./Team.vue?vue&type=style&index=0&id=04063956&prod&lang=scss"
import style1 from "./Team.vue?vue&type=style&index=1&id=04063956&prod&lang=scss&scoped=true"
import style2 from "./Team.vue?vue&type=style&index=2&id=04063956&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04063956",
  null
  
)

export default component.exports